import {
  Component,
  OnDestroy,
  ViewChild,
  OnInit,
  ViewContainerRef,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SubSink } from "subsink";

import { ConfigurationService } from "@/shared-module/services";
import { Member, TeamTexts } from "@/core/models";
import { Configuration } from "@/shared-module/models";

@Component({
  selector: "app-member-remove",
  templateUrl: "member-remove.component.html",
})
export class MemberRemoveComponent implements OnDestroy, OnInit {
  @ViewChild("template", { static: true }) template;
  @Output() submitted: EventEmitter<any> = new EventEmitter();
  @Output() cancelled: EventEmitter<void> = new EventEmitter();
  @Input() data: Member;
  @Input() texts: TeamTexts;
  @Input() errorMessage: string;

  memberForm: FormGroup;
  subs = new SubSink();
  cssColor: string;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private configurationService: ConfigurationService,
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.cssColor = c.cssColor;
      },
    );
  }

  onSubmit() {
    this.submitted.emit(this.memberForm.value);
  }

  cancel() {
    this.cancelled.emit();
  }

  get userName() {
    return this.memberForm.get("userName");
  }

  get password() {
    return this.memberForm.get("password");
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);

    this.memberForm = new FormGroup({
      userName: new FormControl("", [Validators.required]),
      password: new FormControl("", [Validators.required]),
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
